import { deleteOrganisationRole } from '@infuse/api/iam/organisation';
import { useGenericDeleteRole } from '@infuse/iam/role/mutations';

export const useDeleteOrganisationRole = () => {
  return useGenericDeleteRole({
    apiFn: deleteOrganisationRole
  });
};
